"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureAccess = void 0;

var _reactRedux = require("react-redux");

var useFeatureAccess = function useFeatureAccess(featureId) {
  return (0, _reactRedux.useSelector)(function (state) {
    return state.featureAccess.byId && state.featureAccess.byId[featureId] && state.featureAccess.byId[featureId].hasAccess;
  });
};

exports.useFeatureAccess = useFeatureAccess;